import React, { Component } from 'react';
import _ from 'lodash';

import TrafficSignsTable from '../components/TrafficSignsTable';

import TrafficSignsModel from '../components/TrafficSignsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, Switch, message } from 'antd';

class TrafficSignsScreen extends Component {

  state = {
    autoReload: (localStorage.getItem('table_autoReload') !== undefined && localStorage.getItem('table_autoReload') == 'true') ? true : false,
    dataLoading: true,
    dataAll: [],
    data: [],
  }

  intervalId = null;

  componentWillMount() {
    this.loadData();

    // Checking auto reload data
    this.intervalId = setInterval(() => {
      if (this.state.autoReload) {
        this.loadData();
      }
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  loadData() {
    this.setState({
      dataLoading: true
    });
    TrafficSignsModel.getAll()
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      })
      .catch(() => {
        message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
        this.setState({
          dataLoading: false,
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['serialNumber'].startsWith(searchText); })
    });
  }
  onSearchDescription(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => {
        if (typeof(d['description']) != 'undefined') {
            return d['description'].startsWith(searchText);
          }
        if (searchText == '') {
          return dataAll
        }
      })
    });
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Informační tabule - Seznam tabulí</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Najít seriové číslo"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 200 }} />
                  <Input.Search
                  placeholder="Najít popis"
                  onSearch={this.onSearchDescription.bind(this)}
                  style={{ width: 200 }} />
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Switch
                  checked={this.state.autoReload}
                  onChange={(checked) => {
                    localStorage.setItem('table_autoReload', checked);
                    this.setState({
                      autoReload: checked
                    });
                  }} /> Automatická obnova
                <Button type="default" onClick={() => { this.loadData() }} style={{ marginRight: 10, marginLeft: 15 }}><Icon type="sync" /></Button>
                {/* {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ parkinglocationFormModalVisible: true }) }}>Nová lokalita</Button>
                  : null} */}
              </Col>
            </Row>
          </div>
          <TrafficSignsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onRowRemoved={() => {
              this.loadData();
            }}
            onAnyFormSuccess={() => {
              this.loadData();
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default TrafficSignsScreen;



// WEBPACK FOOTER //
// ./src/screens/TrafficSignsScreen.js